<template>
  <div>
		<div>
			<div class="result-bar-wrap t2">
				<div class="tab-1" v-if="result.level === 1">低风险</div>
				<div class="tab-2" v-if="result.level === 2">高风险</div>
				<div class="r-bar"></div>
				<div v-if="result.level === 1" class="c-0"></div>
				<div v-if="result.level === 2" class="c-2"></div>
				<div style="font-size:20px;">
					您存在睡眠呼吸暂停（OSAHS）的风险级别为： 
					<span v-if="result.level === 1" class="t-0">低风险</span>
					<span v-if="result.level === 2" class="t-2">高风险</span>
				</div>
			</div>
			
		</div>
		<h3>相关因素</h3>
		<div>
			<table>
				<tr>
					<th>睡眠呼吸暂停的相关因素</th>
					<th>说明</th>
					<th>本次评估结果</th>
					<th>上次评估结果</th>
				</tr>
				<tr v-for="item in Object.keys(result.other.riskFactors)" :key="item">
					<td>{{ result.other.riskFactors[item].name }}</td>
					<td>{{ result.other.riskFactors[item].explain }}</td>
					<td>
						<span v-if="result.other.riskFactors[item].value && result.other.riskFactors[item].key != 'sum'">✓</span>
						<span v-if="result.other.riskFactors[item].value && result.other.riskFactors[item].key == 'sum'">{{result.other.riskFactors[item].value}}</span>
					</td>
					<td></td>
				</tr>
			</table>
			<div style="color: #999;">关注表中与睡眠呼吸暂停相关的危险因素并进行调节，调节方案详见睡眠处方。</div>
		</div>
  </div>

</template>

<script>
import mixin from '@/views/mixin';
import api from '@/service/api.js';

export default {  
	props: {
		result: Object
	},
	// watch: {
	// 	visible() {
	// 		if (this.visible) {
	// 			this.filter.type = this.type;
	// 			this.loadList();
	// 		}
	// 	}
	// },	
	data(){
		return {}
	},
	created() {},
	methods: {}
}
</script>

<style lang="less" scoped>
// @import './template.less';	
</style>
